/* ==========================================================================
   Collection grid - load more corrector.

   BUG 1 - MISSING PRODUCTS
   The loader in sections/gwb-collection-grid.liquid iterates freshGrid.children
   (a LIVE HTMLCollection) while appendChild MOVES each node out of it. The
   collection shifts down as forEach increments, so roughly every SECOND product
   of each fetched page is skipped. Page 1 is server-rendered and complete;
   every page after loses about half - a 32-product category showed ~22.

   BUG 2 - COUNTERS STUCK AT "12 of 32"
   Every fetched page carries its own counter markup reading "Showing 12 of 32",
   because a page only renders 12 items. Copying that text across rewrites the
   count back to 12 each time. Counts must be MEASURED from the DOM, never
   copied from the fetched page.

   WHY THE COUNTER IS FOUND BY TEXT, NOT BY CLASS
   Targeting a fixed class (.gwbfb__applied) only updated the bottom counter -
   the line above the grid stayed at 12. Rather than keep guessing at markup
   that has been edited across several theme rounds, this scans for any element
   whose text matches "Showing <number> of <number>" and updates all of them.
   That works regardless of which section renders it or what it is called.

   WHY THIS LIVES HERE
   gwb-collection-grid.liquid is ~28KB and the Shopify API has no partial-file
   edit, so changing one line means rewriting the whole file, which exceeds the
   write limit. This script takes over load-more entirely: it reads the next
   URL, blanks data-next so the section's loader exits early, and handles the
   rest itself.
   ========================================================================== */
(function () {
  var RE = /Showing\s*(\d[\d,]*)\s*of\s*(\d[\d,]*)/i;

  function init() {
    var grid = document.getElementById('GwbGrid');
    if (!grid || grid.dataset.gwbFixed === '1') return;
    grid.dataset.gwbFixed = '1';

    var wrap = document.getElementById('GwbLoadMore');
    var link = document.getElementById('GwbLoadMoreLink');
    var spin = document.getElementById('GwbLoadMoreSpin');
    var barEl = document.getElementById('GwbLoadMoreBar');

    /* Find every "Showing X of Y" counter on the page, whatever renders it.
       Only the innermost matching element is kept, so parent wrappers that
       happen to contain the same text are not rewritten. */
    function findCounters() {
      var out = [];
      var all = document.querySelectorAll('body *');
      Array.prototype.forEach.call(all, function (el) {
        if (!RE.test(el.textContent || '')) return;
        for (var i = 0; i < el.children.length; i++) {
          if (RE.test(el.children[i].textContent || '')) return; // a child matches - not innermost
        }
        out.push(el);
      });
      return out;
    }

    var counters = findCounters();

    var total = 0;
    for (var i = 0; i < counters.length; i++) {
      var m = RE.exec(counters[i].textContent);
      if (m) { total = parseInt(m[2].replace(/,/g, ''), 10); break; }
    }
    if (!total) total = grid.querySelectorAll('a.gwbpc').length;

    /* Rewrite just the two numbers, leaving everything else in the element
       intact - the top line also carries the active filter name and the
       "Clear all" link, which must survive. */
    function writeCounter(el, shown) {
      var bolds = el.querySelectorAll('b');
      if (bolds.length >= 2 && /^\s*\d[\d,]*\s*$/.test(bolds[0].textContent)) {
        bolds[0].textContent = shown;
        bolds[1].textContent = total;
        return;
      }
      // No bold pair - rewrite the matching text node in place.
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node, joined = '';
      var nodes = [];
      while ((node = walker.nextNode())) { nodes.push(node); joined += node.nodeValue; }
      if (!RE.test(joined)) return;
      if (nodes.length === 1) {
        nodes[0].nodeValue = nodes[0].nodeValue.replace(RE, 'Showing ' + shown + ' of ' + total);
        return;
      }
      for (var j = 0; j < nodes.length; j++) {
        if (/Showing/i.test(nodes[j].nodeValue)) {
          nodes[j].nodeValue = nodes[j].nodeValue.replace(/Showing\s*\d[\d,]*/i, 'Showing ' + shown);
        } else if (/^\s*of\s*\d/i.test(nodes[j].nodeValue)) {
          nodes[j].nodeValue = nodes[j].nodeValue.replace(/of\s*\d[\d,]*/i, 'of ' + total);
        }
      }
    }

    function refreshCounts() {
      var shown = grid.querySelectorAll('a.gwbpc').length;
      counters.forEach(function (el) { writeCounter(el, shown); });
      if (barEl) {
        var pct = total ? Math.min(100, Math.round((shown * 100) / total)) : 100;
        barEl.style.width = pct + '%';
      }
    }

    if (!wrap) { refreshCounts(); return; }

    var nextUrl = wrap.getAttribute('data-next') || '';
    wrap.setAttribute('data-next', '');      // disables the section's own loader
    var loading = false;

    function seenHrefs() {
      var set = {};
      Array.prototype.forEach.call(grid.querySelectorAll('a.gwbpc'), function (a) {
        set[a.getAttribute('href')] = true;
      });
      return set;
    }

    function loadNext() {
      if (!nextUrl || loading) return;
      loading = true;
      if (link) link.hidden = true;
      if (spin) spin.hidden = false;

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.getElementById('GwbGrid');
          var freshWrap = doc.getElementById('GwbLoadMore');

          if (freshGrid) {
            var kids = Array.prototype.slice.call(freshGrid.children);  // STATIC copy
            var seen = seenHrefs();
            kids.forEach(function (child) {
              if (child.classList &&
                  (child.classList.contains('gwbstrip') || child.classList.contains('gwbtile'))) return;
              var href = child.getAttribute && child.getAttribute('href');
              if (href && seen[href]) return;
              if (href) seen[href] = true;
              grid.appendChild(child);
            });
            if (window.__gwbWireGrid) window.__gwbWireGrid(grid);
          }

          // ONLY the next URL comes from the fetched page - see BUG 2.
          nextUrl = freshWrap ? (freshWrap.getAttribute('data-next') || '') : '';
          if (!nextUrl) wrap.hidden = true;
          else if (link) link.href = nextUrl;

          refreshCounts();
        })
        .catch(function (err) {
          console.warn('[gwb-load-more] failed', err);
          if (link) link.hidden = false;
        })
        .finally(function () {
          loading = false;
          if (spin) spin.hidden = true;
          window.requestAnimationFrame(check);
        });
    }

    function check() {
      if (!nextUrl || loading || wrap.hidden) return;
      if (wrap.getBoundingClientRect().top < window.innerHeight + 600) loadNext();
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '600px 0px 0px 0px' }).observe(wrap);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if (link) link.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });

    refreshCounts();
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
